module.exports = __webpack_public_path__ + "static/nike_github_logo-4e2289981def67d6d4f3c8f56832f48b.png";